import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class KnowledgeQuotationTargetId extends PrimitiveValueObject<string> {
  static create(value: string): KnowledgeQuotationTargetId {
    if (value === null) {
      return new KnowledgeQuotationTargetId('');
    }
    return new KnowledgeQuotationTargetId(value);
  }
}
